export default __webpack_public_path__ + "static/media/secondOne.9070103c.mp4";